import React from 'react';
import { Center, Box } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
var Label = function Label(_ref) {
  var label = _ref.label;
  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(Center, {
    as: "span",
    display: "inline-flex",
    "data-object-type": "core-label",
    "data-attribute": label.type
  }, label.type === 'iconOnlyLabel' && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    mx: 2
  }, /*#__PURE__*/React.createElement(Icon, label.options.icon)), label.type === 'iconLeft' && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    mr: 2
  }, /*#__PURE__*/React.createElement(Icon, label.options.icon)), (label.type === 'textOnlyLabel' || label.type === 'iconLeft' || label.type === 'iconRight') && label.options.text, label.type === 'iconRight' && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    ml: 2
  }, /*#__PURE__*/React.createElement(Icon, label.options.icon)));
};
Label.displayName = "Label";
export { Label };